<template>
  <div class="faceTwoForm">
    <img class="faceBg" src="@/assets/imgs/faceTwoBg.png" alt="" />
    <div class="tips">请录制 <span>3-5秒多次眨眼</span> 视频</div>
    <div class="button">
      <van-button type="primary" block @click="initGetUserMedia">
        录制动作
      </van-button>
    </div>
    <div class="videoForm" v-show="showVideo">
      <video
        id="video"
        :autoplay="true"
        object-fit="cover"
        :show-mute-btn="false"
        :show-play-btn="false"
        :show-progress="false"
        playsinline
        webkit-playsinline="true"
        style="width: 100vw; height: 100vw"
      ></video>
      <div class="tag">剩余{{ s }}秒</div>
      <div class="button">
        <van-button type="primary" block @click="faceEnd">结束录制</van-button>
      </div>
    </div>
  </div>
</template>
<script>
  import Api from '@/api'
  import { mapState } from 'vuex'
  import { Toast } from 'vant'

  export default {
    data() {
      return {
        streamIns: null, // 视频流
        showVideo: false,
        recorder: {},
        stream: {},
        chunks: null,
        chunksUrl: null,
        s: 5,
        time: null,
        videoType: 'video/webm',
      }
    },
    computed: {
      ...mapState({
        signInfo: state => state.sign,
        formData: state => state.authentication,
      }),
    },

    created() {
      // 判断是否支持视频流
      if (!navigator.mediaDevices || !window.MediaRecorder) {
        this.$router.replace('/authentication/face/faceSecond')
      } else {
        // 判断MediaRecorder支持的视频类型
        if (window.MediaRecorder.isTypeSupported('video/webm')) {
          this.videoType = 'video/webm'
        } else if (window.MediaRecorder.isTypeSupported('video/mp4')) {
          this.videoType = 'video/mp4'
        } else {
          this.$router.replace('/authentication/face/faceSecond')
        }
      }
    },
    mounted() {
      // this.initGetUserMedia()
    },
    methods: {
      async livenessVerifyDirect(videoBase64) {
        this.toast = this.$toast.loading({
          message: '签署中...',
          forbidClick: true,
          loadingType: 'spinner',
          duration: 60000,
        })
        try {
          const param = {
            flowId: this.signInfo.flowId,
            idCardNo: this.formData.idCardNo,
            userName: this.formData.userName,
            // videoType: 'webm',
            // 去掉前缀, 只保留格式
            videoType: this.videoType.split('/')[1],
            // videoBase64: videoBase64.replace('data:video/webm;base64,', ''),
            videoBase64: videoBase64.replace(
              `data:${this.videoType};base64,`,
              ''
            ),
          }
          const { data } = await Api.livenessVerifyDirect(param)
          this.toast.clear()
          const { verifyStatus } = data
          if (verifyStatus === '1') {
            this.$router.push('/authentication/face/result')
          }
        } catch (error) {
          console.log(111, error)
          this.faceEnd()
        } finally {
          this.toast.clear()
        }
      },

      async initGetUserMedia() {
        this.showVideo = true
        const constraints = {
          video: {
            width: 640,
            height: 640,
            facingMode: 'user',
          },
        }
        try {
          const stream = await navigator.mediaDevices.getUserMedia(constraints)
          const recorder = new window.MediaRecorder(stream, {
            mimeType: this.videoType,
          })

          this.recorder = recorder
          const video = document.querySelector('#video')
          video.srcObject = stream
          video.play()

          // 存储录制的视频块
          const recordedChunks = []

          // 监听数据可用事件
          recorder.ondataavailable = event => {
            if (event.data.size > 0) {
              console.log('event-size: ', event.data.size / 1024 / 1024)
              recordedChunks.push(event.data)
            }
          }

          recorder.onstart = () => {
            this.s = 5
            this.time = setInterval(() => {
              this.s -= 1
              if (this.s === 0) {
                clearInterval(this.time)
                recorder.stop()
              }
            }, 1000)
          }

          // 监听停止录制事件
          recorder.onstop = () => {
            const that = this
            // 创建 Blob 对象
            const blob = new Blob(recordedChunks, { type: that.videoType })

            // 使用 FileReader 将 Blob 转换为 base64
            const reader = new FileReader()

            reader.onloadend = () => {
              const base64data = reader.result
              that.livenessVerifyDirect(base64data)
            }
            reader.readAsDataURL(blob)
          }

          // 开始录制
          recorder.start()
        } catch (error) {
          console.log('-----: ', error)
          if (error.name === 'NotAllowedError') {
            this.$toast('您拒绝了访问摄像头的请求。')
          } else if (error.name === 'NotFoundError') {
            this.$toast('没有找到任何可用的媒体设备。')
          } else if (error.name === 'NotSupportedError') {
            this.$toast('浏览器不支持媒体设备。')
          } else if (error.name === 'NotReadableError') {
            this.$toast('媒体设备被占用或存在硬件问题。')
          } else if (error.name === 'OverconstrainedError') {
            this.$toast('指定的约束无法满足。')
          } else if (error.name === 'SecurityError') {
            this.$toast('安全错误，可能是由于不安全的上下文或其他限制。')
          } else if (error.name === 'TypeError') {
            this.$toast('设备请求类型错误，请检查约束对象。')
          } else {
            this.$toast(`未知错误: ${error.message}`)
          }
          this.faceEnd()
          // setTimeout(() => {
          //   this.$router.back(-1)
          // }, 3000)
        }
      },

      faceEnd() {
        this.recorder.stop()
        this.s = 5
        clearInterval(this.time)
        this.showVideo = false
      },

      // init() {
      //   const that = this
      //   setTimeout(() => {
      //     console.log(navigator.mediaDevices)
      //   }, 2000)

      //   navigator.mediaDevices
      //     .getUserMedia({
      //       video: { width: 375, height: 375, facingMode: 'user' },
      //     })
      //     .then(function(stream) {
      //       /* 使用这个stream stream */
      //       that.recorder = new window.MediaRecorder(stream)
      //       that.stream = stream
      //     })
      //     .catch(function(err) {
      //       /* 处理error */
      //       console.log(err)
      //     })
      // },
      clickStart() {
        this.showVideo = true
        this.$nextTick(() => {
          this.bindEvents()
          this.preview()
          this.onStart()
        })
      },
      bindEvents() {
        const that = this
        this.recorder.ondataavailable = e => {
          this.chunks = e.data
        }
        this.recorder.onstart = () => {
          that.s = 5
          that.time = setInterval(() => {
            that.s -= 1
            if (that.s === 0) {
              clearInterval(that.time)
              that.clickEnd()
            }
          }, 1000)
        }
        this.recorder.onstop = () => {
          const blob = new Blob([this.chunks], { type: that.videoType })
          const videoStream = URL.createObjectURL(blob)
          this.chunksUrl = videoStream
          this.blobTobase64(blob)
        }
      },
      blobTobase64(blob) {
        const that = this
        const reader = new FileReader()
        reader.onload = e => {
          that.livenessVerifyDirect(e.target.result)
          return e.target.result
        }
        reader.readAsDataURL(blob)
      },

      preview() {
        const video = document.querySelector('#video')
        if ('srcObject' in video) {
          try {
            video.srcObject = this.stream
          } catch (err) {
            if (err.name !== 'TypeError') {
              throw err
            }
            video.src = URL.createObjectURL(this.stream)
          }
        } else {
          video.src = URL.createObjectURL(this.stream)
        }
        video.onloadedmetadata = function(e) {
          video.play()
        }
      },
      onStart() {
        this.recorder.start()
      },
      clickEnd() {
        clearInterval(this.time)
        this.toast = this.$toast.loading({
          message: '签署中...',
          forbidClick: true,
          loadingType: 'spinner',
          duration: 60000,
        })
        this.recorder.stop()
        const video = document.querySelector('#video')
        video.pause()
        this.showVideo = false
      },
    },
  }
</script>
<style lang="less" scoped>
  .faceTwoForm {
    .faceBg {
      width: 100%;
      margin-bottom: 60px;
    }
    .tips {
      font-size: 14px;
      font-family: PingFangSC, PingFangSC-Medium;
      font-weight: bold;
      text-align: center;
      color: #111a34;
      line-height: 20px;
      margin-bottom: 24px;
      span {
        font-size: 20px;
        color: #1676ff;
      }
    }
    .button {
      padding: 0 16px;
    }
    .videoForm {
      position: absolute;
      left: 0;
      top: 0;
      background: #666;
      width: 100%;
      height: 100%;
      .tag {
        font-size: 14px;
        color: #fff;
        text-align: center;
        margin-bottom: 20px;
      }
      #video {
        width: 100%;
        margin-bottom: 20px;
      }
    }
  }
</style>
